import React, { useState } from "react";
import { colors } from "../../../themes/Colors";

const TabButton = ({
  label,
  onClick,
  marginRight,
  width,
  borderColor,
  fontWeight,
  selected,
}) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      onClick={onClick}
      className="Button"
      style={{
        minWidth: width,
        width: width,
        // borderRadius: 4,
        backgroundColor: selected ? colors.white : hover ? colors.white : null,

        display: "flex",
        alignItems: "center",
        minHeight: 40,
        height: 40,
        marginRight: marginRight,
        cursor: "pointer",
        transition: "all 0.05s",
        position: "relative",
      }}
    >
      <h5
        style={{
          // color: hover ? colors.secondary : borderColor,
          marginLeft: 10,
          fontWeight: fontWeight,
        }}
      >
        {label}
      </h5>
      <div style={{ flex: 1 }} />
      <div
        style={{
          position: "absolute",
          bottom: 0,
          // borderBottomStyle: "solid",
          width: selected ? width : hover ? width : 0,
          height: 4,
          backgroundColor: borderColor,
          transition: "width 0.2s",
        }}
      />
    </div>
  );
};

export default TabButton;
